// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2026 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { ApiHandlerDiscreteParameter, createHandlerChainRunner } from "@insite/client-framework/HandlerCreator";
import { ServiceResult } from "@insite/client-framework/Services/ApiService";
import { getCookie } from "@insite/mobius/utilities/cookies";
import {
    getSearchContents,
    SearchContentsModel,
    SearchContentsParameter,
} from "@vanmeter/App/Services/SearchContentService";

const searchContentsPageSizeCookie = "SearchContents-PageSize";

type HandlerType = ApiHandlerDiscreteParameter<
    SearchContentsParameter,
    SearchContentsParameter,
    ServiceResult<SearchContentsModel>
>;

export const PopulateApiParameter: HandlerType = props => {
    const page = props.parameter.page && props.parameter.page > 0 ? props.parameter.page : 1;
    let pageSize = props.parameter.pageSize;

    if (!pageSize || pageSize <= 0) {
        const cookiePageSize = parseInt(getCookie(searchContentsPageSizeCookie) || "", 10);
        if (cookiePageSize > 0) {
            pageSize = cookiePageSize;
        }
    }

    props.apiParameter = {
        term: props.parameter.term,
        page,
        ...(pageSize && pageSize > 0 ? { pageSize } : {}),
    };
};

export const DispatchBeginLoadSearchContents: HandlerType = props => {
    props.dispatch({
        type: "xSearchContents/StartLoading",
        parameter: props.apiParameter,
    });
};

export const RequestDataFromApi: HandlerType = async props => {
    props.apiResult = await getSearchContents(props.apiParameter);
};

export const DispatchCompleteLoadSearchContents: HandlerType = props => {
    props.dispatch({
        type: "xSearchContents/CompleteLoading",
        searchContents: props.apiResult.successful ? props.apiResult.result : undefined,
    });
};

export const chain = [
    PopulateApiParameter,
    DispatchBeginLoadSearchContents,
    RequestDataFromApi,
    DispatchCompleteLoadSearchContents,
];

const searchContentsHandler = createHandlerChainRunner(chain, "searchContentsHandler");
export default searchContentsHandler;
